// extracted by mini-css-extract-plugin
export default {"group":"BuXULB6n","cell":"DV95xrib","active":"f91xDyGa"};